<template>
    <div v-if="tableShow">
        <h3 class="title-content mb-5">
            {{ $t('MY_ORDERS') }}
        </h3>
        <v-data-table
            :headers="headers"
            :items="ordersOnCurrentPage"
            :hide-actions="true"
            :no-data-text="$t('EMPTY_LIST')"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.number }}</td>
                <td class=" text-xs-left">{{ $t(props.item.name) }}</td>
                <td class=" text-xs-left">{{ props.item.price }}</td>
                <td class=" text-xs-left">{{ props.item.orderStatus }}</td>
                <td class=" text-xs-left">{{ dateFormat(props.item.dateOrder) }}</td>
            </template>
        </v-data-table>
        <div v-if="numberOfPages > 1">
            <v-pagination
                :length="numberOfPages"
                :total-visible="numberOfTotalVisiblePages"
                prev-icon="arrow_back"
                next-icon="arrow_forward"
                v-model="currentlyDisplayedPage"
            ></v-pagination>
        </div>
        <div class="rotate-phone mobile">
            <p class="rotate-phone__text">
                {{ $t('ROTATE_PHONE') }}
            </p>
        </div>
    </div>
</template>

<script>
import Modal from '../../modals/_modal.vue';
import ActivatePackage from '../../modals/activate-package.vue';
import ActivateAnotherPackage from '../../modals/activate-another-package.vue';
import { config } from './../../../main';
import moment from 'moment';

export default {
    data() {
        return {
            showModal: false,
            choosemItem: null,
            tableShow: false,
            headers: [
                {
                    text: this.$t('NUMBER'),
                    align: 'left',
                    sortable: true,
                    value: 'number',
                },
                { text: this.$t('PURCHASES'), value: 'name', align: 'left' },
                { text: this.$t('PRICE'), value: 'price', align: 'left' },
                { text: this.$t('STATUS'), value: 'actions', align: 'left' },
                { text: this.$t('ORDER_DATE'), value: 'date', align: 'left' },
            ],
            orders: [],
            lastStockExpirationDate: null,
            currentlyDisplayedPage: 1,
            numberOfOrdersOnOnePage: 5,
        };
    },
    methods: {
        closeModal() {
            this.showModal = false;
        },
        getOrders() {
            this.tableShow = false;
            var url = `/user/api/shop/getOrderUser/`;
            this.$http.get(url, { emulateJSON: true }).then(response => {
                var orders = [];
                response.body.forEach(function(order) {
                    var codeView = false;
                    var codeActive = false;
                    var codeSend = false;
                    if (order.code != null) {
                        codeView = true;
                    }

                    if (order.assigned != null) {
                        codeActive = true;
                    }

                    if (order.sendViaEmail != null) {
                        codeSend = true;
                    }

                    var old = false;
                    if (moment(order.codeValid) < moment(Date.now())) {
                        old = true;
                    }

                    orders.push({
                        number: order.number,
                        name: order.itemName,
                        price: order.total,
                        date: order.codeValid,
                        dateValid: order.dateExpiration,
                        expire: order.expire,
                        dateOrder: order.dateOrder,
                        status: {
                            send: codeSend,
                            active: codeActive,
                            free: false,
                            view: codeView,
                            old: old,
                        },
                        orderStatus: order.status,
                        code: order.code,
                    });
                });
                this.orders = orders;
                this.tableShow = true;
            });
        },
    },
    computed: {
        numberOfPages() {
            return Math.ceil(this.orders.length / this.numberOfOrdersOnOnePage);
        },
        numberOfTotalVisiblePages() {
            return this.numberOfPages < 10 ? this.numberOfPages : 10;
        },
        ordersOnCurrentPage() {
            return this.orders.slice(
                (this.currentlyDisplayedPage - 1) * this.numberOfOrdersOnOnePage,
                this.currentlyDisplayedPage * this.numberOfOrdersOnOnePage,
            );
        },
    },
    components: {
        Modal,
        ActivatePackage,
        ActivateAnotherPackage,
    },
    created() {
        this.getOrders();
    },
};
</script>



// WEBPACK FOOTER //
// purchases.vue?e42d4320